import { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';

export const useWinningPremiumCoupons = (date = '') => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCoupons = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await api.getWinningPremiumCoupons(24, date);
      setCoupons(data.coupons || []);
    } catch (err) {
      setError(err.message);
      setCoupons([]);
    } finally {
      setLoading(false);
    }
  }, [date]);

  useEffect(() => {
    fetchCoupons();
  }, [fetchCoupons]);

  return {
    coupons,
    loading,
    error,
    refetch: fetchCoupons
  };
};
